<template>
	<div class="vendor container-fluid py-2">
		<router-view @childrenRoute="hideNonChildren" />
		<div class="row" v-if="hasPageChild==0">
			<div class="col-md-6 mb-4" v-show="false">
				<BarCard title="INVOICE OVERDUE" :data="invoice.overdue.chart" :width="500" :height="280"/>
			</div>

			<div class="col-md-12 mb-0 pl-0">
				<ListItem class=" mb-0" title="TOP 10 HUTANG" :data="reportdata.data" itemcol="VendorName" valuecol="SumAmountInDC" 
					textvaluecol="FungsiName"
					url="/finance/report-group?tab=10&vendor="/>
			</div>

			<div v-if="false" class="col-md-12 mb-0 pl-0">
				<ListItemHutangByAging class="mb-0" title="TOP 10 HUTANG BY AGING" :data="reportdatautangbyaging.data" itemcol="Name" valuecol="SumAmountInDC" 
					textvaluecol="FungsiName"
					url="/finance/report-group?tab=10&vendor="/>
			</div>
		</div>
	</div>

</template>

<script>
import ListItem from '@/views/pages/ListItem3.vue'
import ListItemHutangByAging from '@/views/pages/ListItemHutangByAging.vue'
import Support from '@/components/page/Support.js'
import BarCard from '@/views/pages/BarCard.vue'
import { Rainbow, FuelColor, Config, Penanggalan, AxiosWithJar } from '@/utility.js'

export default{
	extends: Support,
	components:{
		BarCard,
		ListItem,
		ListItemHutangByAging,
    },
    mounted(){
		this.loadInvoice();
		this.getData()
		this.getDataTopHutangByAging()
    },
	data() {
		return {
			loading: {
				table: false,
			},
			reportdata: [],
			reportdatautangbyaging: {
				data:[],
			},
		}
	},
	watch: {

	},
    methods:{	
		getData() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/vendor/top-utang?'
            
            //this.urlRequestParams+='year='+this.year
            //this.urlRequestParams+='&month='+this.month

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdata = response.data;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },

		getDataTopHutangByAging() {
            this.urlRequestParams=Config().apiURL
			this.urlRequestParams+='/vendor/top-utang-by-aging?'
            
            //this.urlRequestParams+='year='+this.year
            //this.urlRequestParams+='&month='+this.month

			this.loading.table = true;
            AxiosWithJar().get(this.urlRequestParams)
            .then((response)=>{ 
                this.reportdatautangbyaging = response.data;
                //console.log('data: ' + JSON.stringify(this.reportData))
            })
			.catch(error => {
				console.log(error)
				//this.errored = true
				//error.response.data
			})
			.finally(() => {
				this.loading.table = false;
			})     

        },
    },
}
</script>
<style>
.home.row1,.home.row2{ height: 300px;}
.text-merah{ color:#c7251c }
.text-biru{ color:#066fb1   }
.text-hijau{ color:#acc437  }
</style>